enum LandlordAccountType {
  Independent = 'independent',
  Manager = 'manager',
}

export { LandlordAccountType };
